import { useCallback } from 'react';
import { AdaptiveSheet } from '../common/AdaptiveSheet';
import { useUIStore } from '../../store/uiStore';
import { PropertyPickerBody } from './PropertyPickerBody';

/**
 * Profile, the structure page, and phone/tablet host for PropertyPickerBody:
 * an AdaptiveSheet around the same body the desktop map route docks directly
 * instead (PropertyDockPanel.web.tsx) — panel-system.md Phase 2, same
 * DefensePlanAssignForm/Sheet split as Phase 1. Mounted globally
 * (app/_layout.tsx) and gated on `activeSheet === 'propertyPicker'`, same as
 * before this split, except on the desktop shell's map route, where
 * app/_layout.tsx suppresses this host in favor of the dock.
 */
export function PropertyPickerSheet() {
  const open = useUIStore((s) => s.activeSheet === 'propertyPicker');
  const sheetOpenTick = useUIStore((s) => s.sheetOpenTick);
  const close = useUIStore((s) => s.closeSheet);

  const handleSheetDismissed = useCallback(() => {
    if (useUIStore.getState().activeSheet === 'propertyPicker') close();
  }, [close]);

  return (
    <AdaptiveSheet
      isOpen={open}
      tick={sheetOpenTick}
      backdrop="light"
      onRequestClose={close}
      onDismiss={handleSheetDismissed}
      dialogWidth={480}>
      <AdaptiveSheet.ScrollView showsVerticalScrollIndicator={false}>
        <PropertyPickerBody visible={open} onClose={close} />
      </AdaptiveSheet.ScrollView>
    </AdaptiveSheet>
  );
}
